import { type IconName } from '@/assets/icons/icons';

type CategoryMeta = { slug: string; label: string; icon: IconName };

// Display order follows this array
export const INTEGRATION_CATEGORIES = [
  { slug: 'apple', label: 'Apple', icon: 'appleOutline' },
  { slug: 'productivity', label: 'Productivity', icon: 'fast' },
  { slug: 'communication', label: 'Communication', icon: 'chat' },
  { slug: 'sales_marketing', label: 'Sales & Marketing', icon: 'tags' },
  { slug: 'data_analytics', label: 'Data & Analytics', icon: 'insights' },
  { slug: 'dev_tools', label: 'Dev Tools', icon: 'code' },
  { slug: 'finance', label: 'Finance', icon: 'creditCard' },
  { slug: 'other', label: 'Other', icon: 'extras' },
] as const satisfies ReadonlyArray<CategoryMeta>;
